import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function LoginPage() {
  const { admin, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  if (admin !== null) {
    return <Navigate to="/" replace />;
  }

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setPending(true);
    setError(null);

    try {
      await login(email, password);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Não foi possível entrar');
    } finally {
      setPending(false);
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Paper
        variant="outlined"
        component="form"
        onSubmit={handleSubmit}
        sx={{ width: '100%', maxWidth: 380, p: 4, display: 'grid', gap: 2.5 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <Box component="img" src="/favicon.svg" alt="" sx={{ width: 32, height: 32 }} />
          <Box>
            <Typography variant="h2">Recompensas</Typography>
            <Typography variant="caption" color="text.secondary">
              Painel administrativo
            </Typography>
          </Box>
        </Box>

        {error === null ? null : (
          <Alert severity="error" variant="outlined">
            {error}
          </Alert>
        )}

        <TextField
          label="E-mail"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
          autoFocus
          fullWidth
        />
        <TextField
          label="Senha"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
          fullWidth
        />
        <Button type="submit" variant="contained" size="large" disabled={pending}>
          {pending ? 'Entrando…' : 'Entrar'}
        </Button>
      </Paper>
    </Box>
  );
}
